import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

//Images
import pic15 from './../../../../images/card/Untitled-15.jpg';
import pic16 from './../../../../images/card/Untitled-16.jpg';
import pic17 from './../../../../images/card/Untitled-17.jpg';
import { getImageUrl } from '../../../pages/Artist/ArtistAvatar';
import dummyimage from "../../../../images/dummyimage.jpeg";
import { formatTime } from '../../../../utils/functions/date';


function Ticket1() {
	return (
		<>
			<span className="ticket-icon-1 mb-3">
				<i className="fa fa-ticket text-primary" />
			</span>

		</>
	)
}
function Ticket2() {
	return (
		<>
			<span className="ticket-icon-1 mb-3 disabled">
				<i className="fa fa-ticket text-primary" />
			</span>
		</>
	)
}

const CardEvent = [
	{ title: 'Envato International Online Meetup 2023', image: pic15, ticketleft: <Ticket1 />, },
	{ title: 'Google I/O Developer Conference', image: pic16, ticketleft: <Ticket2 />, },
	{ title: 'Apple Worldwide Developers Conference (WWDC)', image: pic17, ticketleft: <Ticket2 />, },
	{ title: 'TED Global Summit 2023', image: pic15, ticketleft: <Ticket2 />, },
	{ title: 'Adobe MAX Creative Conference', image: pic16, ticketleft: <Ticket1 />, },
];

const RecentEvenList = ({ eventlist, total }) => {
	return (
		<>
			<div className="card event-bx">
				<div className="card-header border-0 mb-0">
					<h4 className="card-title font-w500">Shows</h4>
				</div>
				<div className="dz-scroll">
					<div className="card-body  loadmore-content pt-0" id="EventListContent">
						{eventlist?.length === 0 && <div className="text-center h-100 d-flex justify-content-center align-items-center"><h4>No Shows Available</h4></div>}
						{eventlist?.map((data, index) => (
							<div className="d-flex justify-content-between pb-3 border-bottom mb-3" key={index}>
								<div className='d-flex gap-2'>
									<div className="image">
										<img src={data?.projectDetails?.squareImage || data?.projectDetails?.bannerImage ? getImageUrl(data?.projectDetails?.squareImage || data?.projectDetails?.bannerImage) : dummyimage} lazyload />
									</div>
									<div className="media-body">
										<h4 className="fs-18 mb-sm-0 mb-2"><Link to={"#"} className="text-black">{data?.projectDetails?.conceptTitle}</Link></h4>
										<span className="fs-14 d-block mb-sm-3 mb-2 text-secondary">
											{[
												data?.performanceVenue?.title ?? data?.performanceVenueDetails?.title ?? '',
												data?.projectDetails?.genre?.name ?? '',
												data?.start_time ? formatTime(data.start_time) : ''
											].filter(Boolean).join(' | ') || '-'}
										</span>
									</div>
								</div>
								<div className="text-right"><h3>{data?.total_crowd_in ?? 0}</h3></div>
							</div>
						))}
					</div>
				</div>
			</div>


		</>
	)
}
export default RecentEvenList;